import { useQuery } from '@tanstack/react-query';

import { getFxRates } from '~/services/fxService';

export const fxRateQueryKeys = {
  all: ['fxRates'] as const,
};

export function useGetFxRates(enabled = true) {
  return useQuery({
    queryKey: fxRateQueryKeys.all,
    queryFn: getFxRates,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
